import { leftColorStrip, roundedRightRectangle } from '@y42/gojs';
import { Binding, GraphObject, GridLayout, Group, Panel, Point, Spot } from 'gojs';
import { dataLineageDiagramConfig, LINEAGE_PARTS } from '../../../../../state/data-lineage-diagram';
import {
  colorStripColorBinding,
  isLayoutPositionedBinding,
  locationBinding,
  zOrderBindings,
} from '../shared/utils/shared-bindings';
import { contentPanel } from './parts/content-panel';
import { groupBackgroundBinding, groupExpandedBinding, groupStrokeBinding } from './utils/bindings';
import { groupMouseHover, groupMouseLeave } from './utils/events';

const $ = GraphObject.make;

export const defaultGroupTemplate = () =>
  $(
    Group,
    Group.Auto,
    {
      isSubGraphExpanded: false,
      isShadowed: true,
      shadowColor: dataLineageDiagramConfig.colors.group.shadow,
      shadowOffset: new Point(0, 5),
      shadowBlur: 15,
      selectionAdorned: false,
      layout: $(GridLayout, {
        wrappingColumn: 1,
      }),
      cursor: 'pointer',
      deletable: false,
      mouseHover: groupMouseHover,
      mouseLeave: groupMouseLeave,
    },

    //Bindings
    groupExpandedBinding(),
    locationBinding(),
    isLayoutPositionedBinding(),
    groupBinding(),
    ...zOrderBindings(),

    //Parts
    $(
      Panel,
      Panel.Horizontal,
      leftColorStrip({}, [colorStripColorBinding()]),
      mainGroupPanel(
        roundedRightRectangle({ name: LINEAGE_PARTS.GROUP_BACKGROUND_NAME }, [
          groupStrokeBinding(),
          groupBackgroundBinding(),
        ]),
        contentPanel(),
      ),
    ),
  );

const mainGroupPanel = (...children: GraphObject[]) =>
  $(
    Panel,
    Panel.Auto,
    {
      defaultAlignment: Spot.Left,
      cursor: 'pointer',
    },
    ...children,
  );

const groupBinding = () => new Binding('group').makeTwoWay();
